function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import { nestLists, LIST_NEST_MODE_HTML, isPortableTextToolkitList, isPortableTextListItemBlock, isPortableTextToolkitSpan, spanToPlainText, isPortableTextBlock, isPortableTextToolkitTextNode, buildMarksTree } from "@portabletext/toolkit";
export { toPlainText } from "@portabletext/toolkit";
import React, { createContext, useMemo, useContext } from "react";
function mergeComponents(parent, overrides) {
  var _a = overrides,
    block = _a.block,
    list = _a.list,
    listItem = _a.listItem,
    marks = _a.marks,
    types = _a.types,
    rest = __objRest(_a, ["block", "list", "listItem", "marks", "types"]);
  return __spreadValues(__spreadProps(__spreadValues({}, parent), {
    block: mergeDeeply(parent, overrides, "block"),
    list: mergeDeeply(parent, overrides, "list"),
    listItem: mergeDeeply(parent, overrides, "listItem"),
    marks: mergeDeeply(parent, overrides, "marks"),
    types: mergeDeeply(parent, overrides, "types")
  }), rest);
}
function mergeDeeply(parent, overrides, key) {
  var override = overrides[key];
  var parentVal = parent[key];
  if (typeof override === "function") {
    return override;
  }
  if (override && typeof parentVal === "function") {
    return override;
  }
  if (override) {
    return __spreadValues(__spreadValues({}, parentVal), override);
  }
  return parentVal;
}
var link = function link(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /* @__PURE__ */React.createElement("a", {
    href: value == null ? void 0 : value.href
  }, children);
};
var underlineStyle = {
  textDecoration: "underline"
};
var defaultMarks = {
  em: function em(_ref2) {
    var children = _ref2.children;
    return /* @__PURE__ */React.createElement("em", null, children);
  },
  strong: function strong(_ref3) {
    var children = _ref3.children;
    return /* @__PURE__ */React.createElement("strong", null, children);
  },
  code: function code(_ref4) {
    var children = _ref4.children;
    return /* @__PURE__ */React.createElement("code", null, children);
  },
  underline: function underline(_ref5) {
    var children = _ref5.children;
    return /* @__PURE__ */React.createElement("span", {
      style: underlineStyle
    }, children);
  },
  "strike-through": function strikeThrough(_ref6) {
    var children = _ref6.children;
    return /* @__PURE__ */React.createElement("del", null, children);
  },
  link: link
};
var defaultLists = {
  number: function number(_ref7) {
    var children = _ref7.children;
    return /* @__PURE__ */React.createElement("ol", null, children);
  },
  bullet: function bullet(_ref8) {
    var children = _ref8.children;
    return /* @__PURE__ */React.createElement("ul", null, children);
  }
};
var DefaultListItem = function DefaultListItem(_ref9) {
  var children = _ref9.children;
  return /* @__PURE__ */React.createElement("li", null, children);
};
var getTemplate = function getTemplate(type, prop) {
  return "Unknown ".concat(type, ", specify a component for it in the `components.").concat(prop, "` prop");
};
var unknownTypeWarning = function unknownTypeWarning(typeName) {
  return getTemplate("block type \"".concat(typeName, "\""), "types");
};
var unknownMarkWarning = function unknownMarkWarning(markType) {
  return getTemplate("mark type \"".concat(markType, "\""), "marks");
};
var unknownBlockStyleWarning = function unknownBlockStyleWarning(blockStyle) {
  return getTemplate("block style \"".concat(blockStyle, "\""), "block");
};
var unknownListStyleWarning = function unknownListStyleWarning(listStyle) {
  return getTemplate("list style \"".concat(listStyle, "\""), "list");
};
var unknownListItemStyleWarning = function unknownListItemStyleWarning(listStyle) {
  return getTemplate("list item style \"".concat(listStyle, "\""), "listItem");
};
function printWarning(message) {
  console.warn(message);
}
var hidden = {
  display: "none"
};
var DefaultUnknownType = function DefaultUnknownType(_ref10) {
  var value = _ref10.value,
    isInline = _ref10.isInline;
  var warning = unknownTypeWarning(value._type);
  return isInline ? /* @__PURE__ */React.createElement("span", {
    style: hidden
  }, warning) : /* @__PURE__ */React.createElement("div", {
    style: hidden
  }, warning);
};
var DefaultUnknownMark = function DefaultUnknownMark(_ref11) {
  var markType = _ref11.markType,
    children = _ref11.children;
  return /* @__PURE__ */React.createElement("span", {
    className: "unknown__pt__mark__".concat(markType)
  }, children);
};
var DefaultUnknownBlockStyle = function DefaultUnknownBlockStyle(_ref12) {
  var children = _ref12.children;
  return /* @__PURE__ */React.createElement("p", null, children);
};
var DefaultUnknownList = function DefaultUnknownList(_ref13) {
  var children = _ref13.children;
  return /* @__PURE__ */React.createElement("ul", null, children);
};
var DefaultUnknownListItem = function DefaultUnknownListItem(_ref14) {
  var children = _ref14.children;
  return /* @__PURE__ */React.createElement("li", null, children);
};
var DefaultHardBreak = function DefaultHardBreak() {
  return /* @__PURE__ */React.createElement("br", null);
};
var defaultBlockStyles = {
  normal: function normal(_ref15) {
    var children = _ref15.children;
    return /* @__PURE__ */React.createElement("p", null, children);
  },
  blockquote: function blockquote(_ref16) {
    var children = _ref16.children;
    return /* @__PURE__ */React.createElement("blockquote", null, children);
  },
  h1: function h1(_ref17) {
    var children = _ref17.children;
    return /* @__PURE__ */React.createElement("h1", null, children);
  },
  h2: function h2(_ref18) {
    var children = _ref18.children;
    return /* @__PURE__ */React.createElement("h2", null, children);
  },
  h3: function h3(_ref19) {
    var children = _ref19.children;
    return /* @__PURE__ */React.createElement("h3", null, children);
  },
  h4: function h4(_ref20) {
    var children = _ref20.children;
    return /* @__PURE__ */React.createElement("h4", null, children);
  },
  h5: function h5(_ref21) {
    var children = _ref21.children;
    return /* @__PURE__ */React.createElement("h5", null, children);
  },
  h6: function h6(_ref22) {
    var children = _ref22.children;
    return /* @__PURE__ */React.createElement("h6", null, children);
  }
};
var defaultComponents = {
  types: {},
  block: defaultBlockStyles,
  marks: defaultMarks,
  list: defaultLists,
  listItem: DefaultListItem,
  hardBreak: DefaultHardBreak,
  unknownType: DefaultUnknownType,
  unknownMark: DefaultUnknownMark,
  unknownList: DefaultUnknownList,
  unknownListItem: DefaultUnknownListItem,
  unknownBlockStyle: DefaultUnknownBlockStyle
};
var PortableTextComponentsContext = createContext(defaultComponents);
var PortableTextComponentsProvider = function PortableTextComponentsProvider(_ref23) {
  var components = _ref23.components,
    children = _ref23.children;
  var value = useMemo(function () {
    return mergeComponents(defaultComponents, components);
  }, [components]);
  return /* @__PURE__ */React.createElement(PortableTextComponentsContext.Provider, {
    value: value
  }, children);
};
function PortableText(_ref24) {
  var input = _ref24.value,
    componentOverrides = _ref24.components,
    listNestingMode = _ref24.listNestingMode,
    _ref24$onMissingCompo = _ref24.onMissingComponent,
    missingComponentHandler = _ref24$onMissingCompo === void 0 ? printWarning : _ref24$onMissingCompo;
  var handleMissingComponent = missingComponentHandler || noop;
  var blocks = Array.isArray(input) ? input : [input];
  var nested = nestLists(blocks, listNestingMode || LIST_NEST_MODE_HTML);
  var parentComponents = useContext(PortableTextComponentsContext);
  var components = useMemo(function () {
    return componentOverrides ? mergeComponents(parentComponents, componentOverrides) : parentComponents;
  }, [parentComponents, componentOverrides]);
  var renderNode = useMemo(function () {
    return getNodeRenderer(components, handleMissingComponent);
  }, [components, handleMissingComponent]);
  var rendered = nested.map(function (node, index) {
    return renderNode({
      node: node,
      index: index,
      isInline: false,
      renderNode: renderNode
    });
  });
  return componentOverrides ? /* @__PURE__ */React.createElement(PortableTextComponentsContext.Provider, {
    value: components
  }, rendered) : /* @__PURE__ */React.createElement(React.Fragment, null, rendered);
}
var getNodeRenderer = function getNodeRenderer(components, handleMissingComponent) {
  function renderNode(options) {
    var node = options.node,
      index = options.index,
      isInline = options.isInline;
    var key = node._key || "node-".concat(index);
    if (isPortableTextToolkitList(node)) {
      return renderList(node, index, key);
    }
    if (isPortableTextListItemBlock(node)) {
      return renderListItem(node, index, key);
    }
    if (isPortableTextToolkitSpan(node)) {
      return renderSpan(node, index, key);
    }
    if (isPortableTextBlock(node)) {
      return renderBlock(node, index, key, isInline);
    }
    if (isPortableTextToolkitTextNode(node)) {
      return renderText(node, key);
    }
    return renderCustomBlock(node, index, key, isInline);
  }
  function renderListItem(node, index, key) {
    var tree = serializeBlock({
      node: node,
      index: index,
      isInline: false,
      renderNode: renderNode
    });
    var renderer = components.listItem;
    var handler = typeof renderer === "function" ? renderer : renderer[node.listItem];
    var Li = handler || components.unknownListItem;
    if (Li === components.unknownListItem) {
      var style = node.listItem || "bullet";
      handleMissingComponent(unknownListItemStyleWarning(style), {
        type: style,
        nodeType: "listItemStyle"
      });
    }
    var children = tree.children;
    if (node.style && node.style !== "normal") {
      var _a = node,
        listItem = _a.listItem,
        blockNode = __objRest(_a, ["listItem"]);
      children = renderNode({
        node: blockNode,
        index: index,
        isInline: false,
        renderNode: renderNode
      });
    }
    return /* @__PURE__ */React.createElement(Li, {
      key: key,
      value: node,
      index: index,
      isInline: false,
      renderNode: renderNode
    }, children);
  }
  function renderList(node, index, key) {
    var children = node.children.map(function (child, childIndex) {
      return renderNode({
        node: child._key ? child : __spreadProps(__spreadValues({}, child), {
          _key: "li-".concat(index, "-").concat(childIndex)
        }),
        index: index,
        isInline: false,
        renderNode: renderNode
      });
    });
    var component = components.list;
    var handler = typeof component === "function" ? component : component[node.listItem];
    var List = handler || components.unknownList;
    if (List === components.unknownList) {
      var style = node.listItem || "bullet";
      handleMissingComponent(unknownListStyleWarning(style), {
        nodeType: "listStyle",
        type: style
      });
    }
    return /* @__PURE__ */React.createElement(List, {
      key: key,
      value: node,
      index: index,
      isInline: false,
      renderNode: renderNode
    }, children);
  }
  function renderSpan(node, _index, key) {
    var markDef = node.markDef,
      markType = node.markType,
      markKey = node.markKey;
    var Span = components.marks[markType] || components.unknownMark;
    var children = node.children.map(function (child, childIndex) {
      return renderNode({
        node: child,
        index: childIndex,
        isInline: true,
        renderNode: renderNode
      });
    });
    if (Span === components.unknownMark) {
      handleMissingComponent(unknownMarkWarning(markType), {
        nodeType: "mark",
        type: markType
      });
    }
    return /* @__PURE__ */React.createElement(Span, {
      key: key,
      text: spanToPlainText(node),
      value: markDef,
      markType: markType,
      markKey: markKey,
      renderNode: renderNode
    }, children);
  }
  function renderBlock(node, index, key, isInline) {
    var _a = serializeBlock({
        node: node,
        index: index,
        isInline: isInline,
        renderNode: renderNode
      }),
      _key = _a._key,
      props = __objRest(_a, ["_key"]);
    var style = props.node.style || "normal";
    var handler = typeof components.block === "function" ? components.block : components.block[style];
    var Block = handler || components.unknownBlockStyle;
    if (Block === components.unknownBlockStyle) {
      handleMissingComponent(unknownBlockStyleWarning(style), {
        nodeType: "blockStyle",
        type: style
      });
    }
    return /* @__PURE__ */React.createElement(Block, __spreadProps(__spreadValues({
      key: key
    }, props), {
      value: props.node,
      renderNode: renderNode
    }));
  }
  function renderText(node, key) {
    if (node.text === "\n") {
      var HardBreak = components.hardBreak;
      return HardBreak ? /* @__PURE__ */React.createElement(HardBreak, {
        key: key
      }) : "\n";
    }
    return node.text;
  }
  function renderCustomBlock(node, index, key, isInline) {
    var Node = components.types[node._type];
    var nodeOptions = {
      value: node,
      isInline: isInline,
      index: index,
      renderNode: renderNode
    };
    if (Node) {
      return /* @__PURE__ */React.createElement(Node, __spreadValues({
        key: key
      }, nodeOptions));
    }
    handleMissingComponent(unknownTypeWarning(node._type), {
      nodeType: "block",
      type: node._type
    });
    var UnknownType = components.unknownType;
    return /* @__PURE__ */React.createElement(UnknownType, __spreadValues({
      key: key
    }, nodeOptions));
  }
  return renderNode;
};
function serializeBlock(options) {
  var node = options.node,
    index = options.index,
    isInline = options.isInline,
    renderNode = options.renderNode;
  var tree = buildMarksTree(node);
  var children = tree.map(function (child, i) {
    return renderNode({
      node: child,
      isInline: true,
      index: i,
      renderNode: renderNode
    });
  });
  return {
    _key: node._key || "block-".concat(index),
    children: children,
    index: index,
    isInline: isInline,
    node: node
  };
}
function noop() {}
export { PortableText, PortableTextComponentsProvider, defaultComponents, mergeComponents };